/**
 * "Voltar preserva a lista" no layout Completo (spec 018 — correção que vale
 * para os dois layouts).
 *
 * Medido em `5c943de`: o "← Tickets" do detalhe levava SEMPRE ao quadro aberto
 * sem busca (`view=board&status=open&q=`) — mesa, visão, status, busca e grupo
 * se perdiam a cada ticket aberto. Agora a lista se lembra do próprio estado e
 * da posição no histórico: se a entrada ANTERIOR do histórico é ela, o voltar
 * é o do navegador (volta a rolagem junto); senão (link direto, veio de outra
 * tela), abre a lista no último estado visto nesta aba.
 */
import { ticketsSearchSchema, type TicketsSearch } from './TicketsPage';

const LAST_KEY = 'erp.tickets.last';

/**
 * Sem lista lembrada: o destino de sempre do "← Tickets". Função, não
 * constante: TicketsPage importa este módulo e este importa o schema dela —
 * avaliar o schema no carregamento do módulo quebraria no ciclo.
 */
const fallback = (): TicketsSearch => ticketsSearchSchema.parse({ view: 'board', status: 'open', q: '' });

export function rememberTicketsList(search: TicketsSearch, historyIndex: number): void {
  // `new` abre o diálogo de novo ticket: não é estado da lista
  const { new: _dialog, ...list } = search;
  try {
    sessionStorage.setItem(LAST_KEY, JSON.stringify({ search: list, historyIndex }));
  } catch {
    /* armazenamento bloqueado: o voltar cai no destino de sempre */
  }
}

export interface TicketsBack {
  /** a entrada anterior do histórico é a lista: `history.back()` */
  viaHistory: boolean;
  /** para onde o link aponta (e o destino quando não há histórico) */
  search: TicketsSearch;
}

export function ticketsBack(currentHistoryIndex: number): TicketsBack {
  try {
    const raw = sessionStorage.getItem(LAST_KEY);
    if (raw) {
      const parsed = JSON.parse(raw) as { search?: unknown; historyIndex?: unknown };
      const search = ticketsSearchSchema.parse(parsed.search ?? {});
      return {
        viaHistory: typeof parsed.historyIndex === 'number' && parsed.historyIndex === currentHistoryIndex - 1,
        search,
      };
    }
  } catch {
    /* lixo no armazenamento: o destino de sempre */
  }
  return { viaHistory: false, search: fallback() };
}
